import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@welldev-group/rcl-button';
import Icon from '@welldev-group/rcl-icon';
import Modal from '@welldev-group/rcl-modal';
import Link from '@welldev-group/rcl-link';

const SubscriptionErrorModal = ({
  isVisible: isVisibleFromProp,
  errorText,
  errorRedirectUrl,
  onClose,
  controlled,
}) => {
  const [isVisibleFromState, setIsVisibleFromState] = useState(
    isVisibleFromProp,
  );

  return (
    <Modal
      className="subscription-error-modal"
      isVisible={controlled ? isVisibleFromProp : isVisibleFromState}
    >
      <Modal.Content className="subscription-error-modal__body" align="center">
        <Icon name="highPriority" showBGColor={true} color="danger" />
        <div className="subscription-error-modal__body-text">{errorText}</div>
      </Modal.Content>
      <Modal.Footer className="subscription-error-modal__footer">
        {errorRedirectUrl ? (
          <Link
            type="button"
            size="small"
            modifier="primary"
            href={errorRedirectUrl}
          >
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.downgrade.footer.link.close',
            )}
          </Link>
        ) : (
          <Button
            label={I18n.t(
              'components.subscription.subscription_feature_details_modal.upgrade.footer.link.close',
            )}
            type="primary"
            size="small"
            onClick={event => {
              if (!controlled) {
                setIsVisibleFromState(false);
              }
              onClose(event);
            }}
          />
        )}
      </Modal.Footer>
    </Modal>
  );
};

SubscriptionErrorModal.defaultProps = {
  isVisible: false,
  errorText: '',
  errorRedirectUrl: null,
  onClose: () => {},
  controlled: true,
};

SubscriptionErrorModal.propTypes = {
  isVisible: PropTypes.bool,
  errorText: PropTypes.string,
  errorRedirectUrl: PropTypes.string,
  onClose: PropTypes.func,
  controlled: PropTypes.bool,
};

export default SubscriptionErrorModal;
